import ResponsiveContainer from "../../layouts/ResponsiveContainer";
import CTABox from "../Cards/CTABox";

interface IContactSection {
    title?: string;
    linkPath?: string;
    buttonLabel?: string;
    space?: string;
}

const ContactSection = ({
    title = "¿Tenés dudas o consultas?",
    linkPath = "/monitor/contactanos",
    buttonLabel = "Contáctanos",
    space = 'mt-12'
}: IContactSection) => {
    return (
        <section className={`flex flex-col items-center bg-brand-baige-10/50 w-full ${space}`}>
            <ResponsiveContainer className='flex flex-col justify-center'>
                <CTABox
                    title={title}
                    linkPath={linkPath}
                    buttonLabel={buttonLabel}
                    background="bg-brand-baige-20"
                    variant='redesign'
                    classNameContainer='my-12 sm:my-[3.25rem] md:my-16'
                />
            </ResponsiveContainer>
        </section>
    );
};

export default ContactSection;